import type { FC } from "react";

import { SelectInputMultiStyle } from "../../documentation/styles/InputStyle";
import type { FormInputProps } from "../Form/types/types";

interface SelectInputProps extends FormInputProps<string[]> {
    placeholder?: string;
    isLoading?: boolean;
    onClick?: () => void;
}

export const SelectInputMulti: FC<SelectInputProps> = ({ children, disabled, onClick, onChange, value, isLoading, ...restProps }) => {
    const onValueChange = (newValue: string[]) => {
        if (onChange) {
            onChange(newValue);
        }
    };

    return (
        <SelectInputMultiStyle
            className={disabled ? "aevi-input aevi-input-select aevi-select-disabled" : "aevi-input aevi-input-select"}
            showSearch
            allowClear
            disabled={disabled}
            loading={isLoading}
            value={value || undefined}
            // @ts-ignore
            onChange={onValueChange}
            onClick={onClick}
            optionFilterProp="displayName"
            {...restProps}
        >
            {children}
        </SelectInputMultiStyle>
    );
};
